import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import styles from "./auth.module.css";

/** Zentrierte Karte, ein Schritt pro Bildschirm. */
export function AuthLayout({
  appTitle,
  title,
  lead,
  children,
}: {
  appTitle: string;
  title: string;
  lead?: ReactNode;
  children: ReactNode;
}) {
  const intl = useIntl();
  return (
    <div className={styles.page}>
      <main id="main" className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.mark} aria-hidden="true">
            {BRAND_MARK}
          </span>
          <span>
            <span className={styles.brandName}>{intl.formatMessage({ id: "app.name" })}</span>
            <span className={styles.appTitle}>{appTitle}</span>
          </span>
        </div>
        <h1 className={styles.title}>{title}</h1>
        {lead ? <p className={styles.lead}>{lead}</p> : null}
        {children}
      </main>
    </div>
  );
}

/** Wortmarke (Logo), kein übersetzbarer Text */
const BRAND_MARK = "aT";
